import { categoryStore, reviewStore } from '@/store';
import {
    ADBLOCK_EXOCLICK,
    DEFAULT_TRAFFIC_SOURCE,
    TRAFFIC_SOURCE_EXOCLICK,
} from '@/constants';
import { mediaQueriesMixin } from './mediaQueries';
import { routeMixin } from './route';

export const partnersMixin = {
    data() {
        return {
            categoryState: categoryStore.state,
            reviewState: reviewStore.state,
        };
    },
    mixins: [mediaQueriesMixin, routeMixin],
    computed: {
        displayedPartners() {
            return this.categoryState?.rankingList || [];
        },
        activeOnlyPartners() {
            return this.categoryState?.rankingList?.filter(
                (partner) => !partner['is_disabled']
            );
        },
        podiumPartners() {
            return this.activeOnlyPartners?.slice(0, 3) || [];
        },
        testimonialPartners() {
            return this.isDesktop()
                ? this.displayedPartners.slice(0, 3)
                : this.displayedPartners.slice(0, 1);
        },
        pageLayoutPartner() {
            return this.$route.name === 'review'
                ? this.reviewState.reviewPartner
                : this.displayedPartners[0];
        },
    },
    methods: {
        getPartners() {
            let trafficSource = DEFAULT_TRAFFIC_SOURCE;
            const category = this.getCategorySlug();
            let uT = '1';
            let brVersion = '';

            if (this.$globalState.trafficSource !== null) {
                trafficSource = this.$globalState.trafficSource;
            } else {
                trafficSource = document
                    .querySelector('#main-ts')
                    .getAttribute('data-ts');
                this.$globalState.trafficSource = trafficSource;
            }

            if (TRAFFIC_SOURCE_EXOCLICK === trafficSource) {
                trafficSource = ADBLOCK_EXOCLICK;
            }

            const hasAbRank = !!this.$route.query.arnk;
            const t = this.$globalConstants.userId;

            if (this.$globalConstants.user.userTimezone !== null) {
                uT = this.$globalConstants.user.userTimezone;
            }
            if (this.$route.query.brnkv) {
                brVersion = this.$route.query.brnkv;
            }

            let url = `/host/${this.$globalConstants.host['id']}/category/${trafficSource}/${category}?arnk=${hasAbRank}&fp=${this.$globalState.fixedPosition}}&t=${t}&uT=${uT}&brnkv=${brVersion}`;

            url = url + '&device_type=' + this.$globalConstants.deviceType;

            // temp until our CMS is connected with the new RankingSource
            if ('1' === this.$route.query.brnk) {
                url = url + '&brnk=' + this.$route.query.brnk;
            }
            if (this.$globalConstants.clickinId) {
                url = url + '&clId=' + this.$globalConstants.clickinId;
            }

            return window.axios.get(url).then((response) => {
                categoryStore.setCategory(response.data.category);
                categoryStore.updateRankingList(response.data.partners);
                reviewStore.setReviewPartners(response.data.partners_review);
            });
        },
        getPartnerById(id) {
            return this.displayedPartners.find(
                (partner) => partner.partner_id === id
            );
        },
    },
};
